export default {
  name: 'dashify:Table',
  title: 'Table',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'table'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [['dashify:CardWithTitle', { '.': 'border-white p-2', title: 'Gauge' }, 'under construction...']],
  },
};
